import { FormatRelativeDates } from "@opendash/core";
import * as React from "react";
import { DataItemInterface, useDataItemValue } from "..";

interface Props {
  item: DataItemInterface;
}

export const DataItemChangedRelative = React.memo<Props>(({ item }) => {
  const value = useDataItemValue(item);

  if (!value) {
    return null;
  }

  return <FormatRelativeDates start={Math.min(value.date, Date.now())} />;
});
